import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useMemo, useRef } from 'react';
import { WALLET_API_BASE } from 'app/config/env';
import { normalizeBearerToken, resolveCmsAccessToken } from 'shared/api/cms-access-token';
import { setCmsHttpAccessTokenGetter, setCmsHttpBaseUrl } from 'shared/api/mfe-axios';
import { setWalletHttpAccessTokenGetter, setWalletHttpBaseUrl } from 'shared/api/wallet-axios';
const CmsApiBaseContext = createContext('');
const normalizeApiBase = (baseUrl) => baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
export const CmsApiBaseProvider = ({ baseUrl, walletApiBase, getAccessToken, getWalletAccessToken, children, }) => {
    const v = useMemo(() => normalizeApiBase(baseUrl), [baseUrl]);
    const walletBase = useMemo(() => normalizeApiBase(walletApiBase || WALLET_API_BASE), [walletApiBase]);
    const tokenRef = useRef(getAccessToken);
    tokenRef.current = getAccessToken;
    const walletTokenRef = useRef(getWalletAccessToken);
    walletTokenRef.current = getWalletAccessToken;
    setCmsHttpBaseUrl(v);
    setCmsHttpAccessTokenGetter(() => {
        const fromRuntime = normalizeBearerToken(tokenRef.current?.());
        if (fromRuntime) {
            return fromRuntime;
        }
        return resolveCmsAccessToken(null) || null;
    });
    setWalletHttpBaseUrl(walletBase);
    setWalletHttpAccessTokenGetter(() => normalizeBearerToken(walletTokenRef.current?.()) || null);
    return _jsx(CmsApiBaseContext.Provider, { value: v, children: children });
};
export const useCmsApiBase = () => useContext(CmsApiBaseContext);
